document.querySelectorAll('.add-address-form').forEach(function(form) {
  form.addEventListener('submit', function() {
    event.preventDefault();
    setTimeout(function() {
      location.href = '/pages/info';
    }, 1000);
  });
});

function closeAllForms() {
  document.querySelectorAll('.address-form').forEach(function(form) {
    form.style.display = 'none';
  });
}

document.querySelectorAll('.default-address-edit-button').forEach(function(button) {
  button.addEventListener('click', function() {
    console.log("click")
    closeAllForms();
    document.getElementById('addressForm').style.display = 'block';
  });
});

document.querySelectorAll('.address-edit-button').forEach(function(button) {
  button.addEventListener('click', function() {
    console.log("click")
    closeAllForms();
    const addressId = button.getAttribute('data-address-id');
    const form = document.getElementById('addressForm' + addressId);
    if (form) {
      form.style.display = 'block';
    }
  });
});

document.querySelectorAll('.address-close-button').forEach(function(button) {
  button.addEventListener('click', function() {
    console.log("click")
    const addressId = button.getAttribute('data-address-id');
    const form = document.getElementById('addressForm' + addressId);
    if (form) {
      form.style.display = 'none';
    }
  });
});

document.querySelectorAll('.deleteAddressButton').forEach(button => {
  button.addEventListener('click', function(event) {
    event.preventDefault(); 
    const customerId = this.getAttribute('data-customer-id');
    const addressId = this.getAttribute('data-address-id');
    let formData = {
        customerId: customerId,
        addressId : addressId
    };
    fetch('https://9sigixtch6.execute-api.ap-northeast-1.amazonaws.com/production/addresses/delete', {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        console.log('Success:', data);
        window.location.href = '/pages/info';
    })
    .catch((error) => {
        alert("削除に失敗しました。お手数ですがもう一度やり直してください。")
        console.error('Error:', error);
    });
  });
});


document.querySelectorAll('.setDefaultAddressButton').forEach(button => {
  button.addEventListener('click', function(event) {
    event.preventDefault(); 
    const customerId = this.getAttribute('data-customer-id');
    const addressId = this.getAttribute('data-address-id');
    console.log(customerId)
    let formData = {
        customerId: customerId,
        addressId : addressId
    };
    fetch('https://9sigixtch6.execute-api.ap-northeast-1.amazonaws.com/production/addresses/set_default', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        console.log('Success:', data);
        window.location.href = '/pages/info';
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  });
});